import React, { Component} from 'react';
import sty from 'styled-components';
import { Link } from 'react-router-dom';

import m from '../../services/media';
import { videos, liveRequest } from '../../services/apiCall';
import Container from '../../components/Container';
import Add from '../../components/Add';
import Live from '../../components/live';

export default class HomeScreen extends Component {
  constructor(props){
    super(props);
    this.state = {
      posts: [],
      live: null,
      page: ""
    }
  }
  componentDidMount(){
    videos(this.state.page).then(response=>{
      console.log(response.nextPageToken);
      
      this.setState({
        posts: response.videos,
        page: response.nextPageToken
      })
    })
    // liveRequest().then(response=>{   
    //   console.log(response);
    //   this.setState({
    //     live: response.videos[0],
    //   })
    // })
  }
  componentDidUpdate(){
    if(this.state.loading){
      videos(this.state.page).then(response=>{
        this.setState({
          posts: this.state.posts.slice().concat(response.videos),
          page: response.nextPageToken,
          loading: false
        })
      })
    }
  }
  handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 200;
    if (bottom) { 
      if(!this.state.loading)
        this.setState({
          loading: true
        })
     }
  }
  render(){
    const posts = this.state.posts.map((post, key)=>{
      var description = post.snippet.description.replace("Curta nossa página: https://www.facebook.com/atibaiatv", "");
      var title = post.snippet.title
      var date = new Date(post.snippet.publishedAt);
      if(date === new Date()){
        date = `Hoje ${date.getHours()}h${date.getMinutes()}`
      } else {
        date = `${date.getDay()<10?'0'+date.getDay():date.getDate()}/${date.getMonth()+1<10?'0'+(date.getMonth()+1):(date.getMonth()+1)} ${date.getHours()}h${date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()}`
      }
      return (
        <PostContainer key={key} to={{pathname: '/video/'+post.contentDetails.videoId, state: {post: post, index: key, posts: this.state.posts}}}>
          <PostImgContainer>
            <PostImg src={post.snippet.thumbnails.high.url || post.snippet.thumbnails.default.url } />
          </PostImgContainer>
          <PostDescription>
            <PostTitle>
              {title}
            </PostTitle>
            <PostText>
                {description.slice(0,100)}
            </PostText>
            <PostDate>
              {date}
            </PostDate>
          </PostDescription>
          {/* {(key+1)%8===0 ? <AddContainer>
            <Add/>
          </AddContainer>:null} */}
        </PostContainer>
      )
    })
    return (
      <Container>
        <Home onScroll={this.handleScroll}>
          {/* <Live live={this.state.live}/>          */}
          <AddContainer>
            <Add/>
          </AddContainer>
          {posts}
        </Home>
      </Container>
    );
  }
}

const Home = sty.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  flex-wrap: wrap;
  ${m.sm`
    padding: 4.5rem 0rem .5rem 0rem;
  `};
  ${m.md`
    padding: 4.5rem .5rem .5rem .5rem;
  `};
  ${m.lg`
   padding: 4.5rem .5rem .5rem .5rem;
  `};
  display: flex;
  justifyContent: center;
  align-items: center
`
const AddContainer = sty.div`
  width: 100%;
  padding: .5rem
`
const PostContainer = sty(Link)`
  flex: 0 0;
  flex-direction: column;
  ${m.sm`
    flex-basis: 100%;
  `};
  ${m.md`
    flex-basis: 50%;
  `};
  ${m.lg`
    flex-basis: 25%;
  `};
`
const PostImgContainer = sty.div`
  display: block;
  position: relative;
  overflow: hidden;
  padding: calc(55% - .5rem) 0 0 0;
  box-shadow: 0 .1rem .3rem #888a;\
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 .1rem .3rem #888;
  }
  ${m.sm`
    width: 100%
    margin: .5rem 0rem 0 0rem;
    border-radius: 0;
    &:hover {
      transform: scale(1);
      box-shadow: 0 .1rem .3rem #888;
    }
  `};
  ${m.md`
    width: calc(100% - 1rem);
    margin: .5rem .5rem 0 .5rem;
    border-radius: .5rem;
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 .1rem .3rem #888;
    }
  `};
  ${m.lg`
    width: calc(100% - 1rem);
    margin: .5rem .5rem 0 .5rem;
    border-radius: .5rem;
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 .1rem .3rem #888;
    }
  `};
  
`
const PostImg = sty.img`
  display: block;
  width: 100%;
  position: absolute;
  top: -17.5%;
  left: 0;
  object-fit: cover;
`
const PostDescription = sty.div`
  padding: .3rem .7rem .7rem .7rem;
  flex-direction: column;
`
const PostTitle = sty.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: 1rem;
  line-height: 1.3rem;
  font-weight: 500;
  overflow: hidden;
  margin: .5rem .5rem;
  padding: .5rem 0 0 0;
  position: relative;
  flex: 1 0;
  &:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 15%;
    height: 1.5em;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 70%);
  };
`
const PostText = sty.h2`
  font-family: 'Ubuntu', sans-serif;
  font-size: .8rem;
  line-height: 1rem;
  font-weight: 400;
  max-height: 3rem;
  margin: 0 .5rem;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1 0;
  -webkit-line-clamp: ellipsis
  &:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 15%;
    height: 1rem;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff 70%);
  };
`
const PostDate = sty.p`
  margin: .5rem .5rem .5rem .5rem;
`
